import { render, staticRenderFns } from "./ProjectsActive.vue?vue&type=template&id=28c65099&"
import script from "./ProjectsActive.vue?vue&type=script&lang=js&"
export * from "./ProjectsActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports